module.exports = __webpack_public_path__ + "media/images/logos/bg-logo-light-3467209134964a771aa1d263d2caf04a.png";